import { Component, OnInit } from '@angular/core';
import { SimpleGlobal } from 'ng2-simple-global';
import { ComunicateComponentService } from '../../_services/comunicate-component.service';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [ComunicateComponentService]
})
export class HeaderComponent implements OnInit {
  cookies: Object;
  isLogin:any;
  showMessage: string = 'test';

  constructor(
    private sg: SimpleGlobal,
    private comunicateComponentService: ComunicateComponentService
  ) {
  //this.isLogin = '';
  //  this.comunicateComponentService.header().
  //  subscribe(
  //   data => console.log(data)
  //  );

    this.cookies = Cookie.getAll();
   }


  ngOnInit() {
  }

  onNotifyClicked(message:string){
    this.showMessage = message;
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/header/header.component.ts